import React from 'react'

import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Checkbox from '@material-ui/core/Checkbox'
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import Step from '@material-ui/core/Step'
import Stepper from '@material-ui/core/Stepper'
import StepLabel from '@material-ui/core/StepLabel'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import CardHeader from '@material-ui/core/CardHeader'
import CardActions from '@material-ui/core/CardActions'
import StepButton from '@material-ui/core/StepButton'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import CircularProgress from '@material-ui/core/CircularProgress'
import Chip from '@material-ui/core/Chip'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import withStyles from '@material-ui/core/styles/withStyles'
import { RenjuBoard, RenjuBoardCard, TitleGrid, Word } from '../../../containers'
import { PuzzleMenuItems } from '../containers'
import * as constants from '../../../constants'
import dateformat from 'dateformat'
import { Link } from 'react-router-dom'
import { makePath } from '../../../lib';
import { WID } from '../../../constants/Language';
import { useContext } from 'react'
import { Auth0Context } from '../../../Parts/Auth0'
import { useState } from 'react'
import { useEffect } from 'react'
import { SettingsContext } from '../../../Parts/Settings'
import { useDispatch } from 'react-redux'
import { types } from '../../../constants/ActionTypes'

const styles = {
  puzzleRegister: (theme) => ({
    root: {
      flexGrow: 1,
    },
    gridRoot: {
      width: '100%',
      maxWidth: '680px',
      margin: '24px auto',
    },
    gridTitle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: theme.spacing.unit * 4,
      color: theme.palette.text.secondary,
    },
    gridButtons: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    pageTitle: {
      margin: 'auto 20px',
    },
    pageTitleIcon: {
      fontSize: 70,
    },
    horizontalLinearStepper: {
      width: '100%',
      maxWidth: 680,
      margin: '0 auto',
    },
    headerTitle: {
      textAlign: 'center',
      margin: theme.spacing.unit * 2,
    },
    button: {
      margin: theme.spacing.unit * 2,
    },
    resultBox: {
      padding: `${theme.spacing.unit * 10}px 0`,
      backgroundColor: 'white',
      width: '100%',
      maxWidth: 680,
      margin: '0 auto',
    }
  }),
  horizontalLinearStepper: (theme) => ({
    stepper: {
      backgroundColor: 'transparent'
    }
  }),
  stepperControlButtons: (theme) => ({
    root: {
      width: '100%',
      maxWidth: '680px',
      margin: '0 auto',
    },
    buttonBox: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    button: {
      marginRight: theme.spacing.unit,
    },
    instructions: {
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
    },
  }),
  stepper1: (theme) => ({
    card: {
      width: '100%',
      maxWidth: '680px',
      margin: '0 auto',
    },
    cardHeader: {
      paddingTop: theme.spacing.unit * 3,
      paddingLeft: theme.spacing.unit * 3,
      paddingBottom: 0,
    },
    cardActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: theme.spacing.unit * 2,
    },
    textField: {
      width: 200,
      marginRight: theme.spacing.unit * 2,
    },
    textFieldWide: {
      width: '100%',
      maxWidth: 400 + theme.spacing.unit * 2,
    },
    levelLabel: {
      color: theme.palette.grey[700],
      lineHeight: 0,
    },
    innerBox: {
      maxWidth: 400 + theme.spacing.unit * 4,
      margin: '0 auto',
    },
    chip: {
      margin: theme.spacing.unit,
    }
  }),
  stepper2: (theme) => ({

  }),
  stepper3: (theme) => ({

  }),
  stepper4: (theme) => ({
    card: {
      width: '100%',
      maxWidth: '680px',
      margin: '0 auto',
    },
    cardHeader: {
      paddingTop: theme.spacing.unit * 3,
      paddingLeft: theme.spacing.unit * 3,
      paddingBottom: 0,
    },
    cardActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: theme.spacing.unit * 2,
    },
    table: {
      width: `calc(100% - ${theme.spacing.unit * 4}px)`,
      margin: `0 auto ${theme.spacing.unit * 4}px`,
    },
    boardViewBox: {
      display: 'flex',
    },
    boardAndTitleBox: {
      width: '100%',
      textAlign: 'center',
    },
    renjuBoardBox: {
      width: '100%',
      maxWidth: 300,
    },
    chip: {
      marginTop: theme.spacing.unit / 2,
      marginRight: theme.spacing.unit,
      marginBottom: theme.spacing.unit / 2,
    }
  }),
}

class HorizontalLinearStepper extends React.Component {  
  render() {
    const { classes, data, completed, activeStep, horizontalLinearStepper } = this.props

    return (
        <Stepper activeStep={activeStep} alternativeLabel className={classes.stepper}>
          {steps.map((step, index) => {
            var buttonProps = { disabled: false }
            if (index === 2 && data.card && data.card.moves.length <= 1) {
              buttonProps = { disabled: true }
            }

            return (
              <Step key={step.wid}>
                <StepButton
                  onClick={horizontalLinearStepper.handleStep(data, index)}
                  completed={completed.has(index)}
                  {...buttonProps}
                >
                  <StepLabel><Word wid={step.wid}/></StepLabel>
                </StepButton>
              </Step>
            )
          })}
        </Stepper>
    )
  }
}

HorizontalLinearStepper = withStyles(styles.horizontalLinearStepper)(HorizontalLinearStepper)


class StepperControlButtons extends React.Component {

  render() {
    const { classes, id, data, completed, activeStep, isFetching, stepperControlButtons } = this.props
    var enableDesideButton = false
    if (completed.size === 3) {
      enableDesideButton = true
    }
    var enableNextButton = true
    if (
      (activeStep === constants.puzzleRegisterStepperType.STEP2_PUZZLE && data.card.moves.length <= 1) ||
      activeStep === constants.puzzleRegisterStepperType.STEP3_ANSWER
    ) {
      enableNextButton = false
    }
    return (
      <div className={classes.root}>
        {activeStep === steps.length ? (
          <div className={classes.buttonBox}>
            <Button
              onClick={stepperControlButtons.handleBack(data, activeStep)}
              className={classes.button}
            >
              <Word wid={WID.PUZZLE_REGISTER.STEPPER1.CONTROL_BUTTONS.BACK_BUTTON}/>
            </Button>
            {isFetching === false ? (
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={stepperControlButtons.handlePost(data)}
              >
                {id ? (
                  <Word wid={WID.PUZZLE_REGISTER.STEPPER1.CONTROL_BUTTONS.UPDATE_BUTTON}/>
                ) : (
                  <Word wid={WID.PUZZLE_REGISTER.STEPPER1.CONTROL_BUTTONS.REGISTER_BUTTON}/>
                )}
              </Button>
            ) : 
            (
              <CircularProgress size={30}/>
            )}
          </div>
        ) : (
          <div className={classes.buttonBox}>
            <Button
              disabled={activeStep === 0}
              onClick={stepperControlButtons.handleBack(data, activeStep)}
              className={classes.button}
            >
              <Word wid={WID.PUZZLE_REGISTER.STEPPER1.CONTROL_BUTTONS.BACK_BUTTON}/>
            </Button>
            <Button
              disabled={!enableDesideButton}
              variant="contained"
              color="primary"
              onClick={stepperControlButtons.handleDecision(data)}
              className={classes.button}
            >
              <Word wid={WID.PUZZLE_REGISTER.STEPPER1.CONTROL_BUTTONS.DECIDE_BUTTON}/>
            </Button>
            <Button
              disabled={!enableNextButton}
              variant="contained"
              color="primary"
              onClick={stepperControlButtons.handleNext(data, activeStep)}
              className={classes.button}
            >
              <Word wid={WID.PUZZLE_REGISTER.STEPPER1.CONTROL_BUTTONS.NEXT_BUTTON}/>
            </Button>
          </div>
        )}
      </div>
    )
  }
}

StepperControlButtons = withStyles(styles.stepperControlButtons)(StepperControlButtons)

class Stepper1 extends React.Component {
  render() {
    const { classes, title, type, level, datetime, checkDateTime, tag, tags, isOtherAnswers, comment, stepper1, headerTitle, actions } = this.props
    var items = constants.puzzleLevelItems.filter((item) => item.value === level)
    var levelHelperText = items.length > 0 ? (<Word wid={items[0].wid}/>) : ''
    return (
      <Card className={classes.card}>
        <CardHeader
            title={headerTitle}
            className={classes.cardHeader}
        />
        <CardContent>
          <div className={classes.innerBox}>
            <div>
              <TextField
                label={<Word wid={WID.PUZZLE_REGISTER.STEPPER1.TITLE_LABEL}/>}
                value={title}
                onChange={stepper1.handleChangedText('title')}
                className={classes.textFieldWide}
              />
            </div>
            <div>
              <TextField
                label={<Word wid={WID.PUZZLE_REGISTER.STEPPER1.PUZZLE_TYPE_LABEL}/>}
                select
                value={type}
                onChange={stepper1.handleChangedText('type')}
                className={classes.textField}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                  },
                }}
                margin="normal"
              >
                {constants.puzzleTypeItems.map((item, index) =>
                  <MenuItem key={index} value={item.value}>
                    <Word wid={item.wid}/>
                  </MenuItem>
                )}
              </TextField>
            </div>
            <div>
            <TextField
                label={<Word wid={WID.PUZZLE_REGISTER.STEPPER1.LEVEL_LABEL}/>}
                select
                value={level}
                helperText={levelHelperText}
                onChange={stepper1.handleChangedText('level')}
                className={classes.textField}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                  },
                }}
                margin="normal"
              >
                {constants.puzzleLevelItems.map((item, index) =>
                  <MenuItem key={index} value={item.value}>
                    <Typography className={classes.levelLabel}>{item.label}</Typography>
                  </MenuItem>
                )}
              </TextField>
            </div>
            <div>
              <TextField
                label={<Word wid={WID.PUZZLE_REGISTER.STEPPER1.OTHER_ANSWERS_LABEL}/>}
                select
                value={isOtherAnswers}
                onChange={stepper1.handleChangedText('isOtherAnswers')}
                className={classes.textField}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                  },
                }}
                margin="normal"
              >
                {constants.puzzleOtherAnswersItems.map((item, index) =>
                  <MenuItem key={index} value={item.value}>
                    <Typography><Word wid={item.wid}/></Typography>
                  </MenuItem>
                )}
              </TextField>
            </div>
            <div>
              <TextField
                label={<Word wid={WID.PUZZLE_REGISTER.STEPPER1.COMMENT_LABEL}/>}
                value={comment}
                onChange={stepper1.handleChangedText('comment')}
                className={classes.textFieldWide}
              />
            </div>
            <div>
              <TextField
                id={"datetime"}
                label={<Word wid={WID.PUZZLE_REGISTER.STEPPER1.RELEASE_DATE_LABEL}/>}
                type="datetime-local"
                value={datetime}
                className={classes.textField}
                onChange={stepper1.handleChangedText('datetime')}
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                disabled={!checkDateTime}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkDateTime}
                    onChange={stepper1.handleChangedCheckbox('checkDateTime')}
                    color='primary'
                  />
                }
                label={<Word wid={WID.PUZZLE_REGISTER.STEPPER1.SPECIFIED_RELEASE_DATE_LABEL}/>}
              />
            </div>
            <div>
              <TextField
                label={<Word wid={WID.PUZZLE_REGISTER.STEPPER1.TAG_LABEL}/>}
                className={classes.textField}
                value={tag}
                onChange={stepper1.handleChangedText('tag')}
                onKeyDown={stepper1.handleKeyDown}
              />
              <Button
                variant="text"
                color="primary"
                className={classes.button}
                onClick={stepper1.handleAddTag}
              >
                <Word wid={WID.PUZZLE_REGISTER.STEPPER1.ADD_TAG_BUTTON}/>
              </Button>
            </div>
            <div>
              {tags && tags.map((name, index) => 
                <Chip
                  key={index}
                  label={name}
                  onDelete={stepper1.handleDeleteTag(index)}
                  className={classes.chip}
                />
              )}
            </div>
          </div>
        </CardContent>
        <CardActions className={classes.cardActions}>
          {actions}
        </CardActions>
      </Card>
    )
  }
}

Stepper1 = withStyles(styles.stepper1)(Stepper1)

class Stepper2 extends React.Component {
  render() {
    const { bid, headerTitle } = this.props
    if (bid < 0) {
      return (<div></div>)
    }
    return (
      <RenjuBoardCard
        bid={bid}
        customHeaderTitle={headerTitle}
        isVisibleUnderHeaderAction={true}
        isVisibleEditModeMenu={true}
        isVisibleOperationMenu={false}
        isVisibleRenjuBoardMenu={false}
      />
    )
  }
}

Stepper2 = withStyles(styles.stepper2)(Stepper2)

class Stepper3 extends React.Component {
  render() {
    const { bid, headerTitle } = this.props
    if (bid < 0) {
      return (<div></div>)
    }
    return (
      <RenjuBoardCard bid={bid}
        customHeaderTitle={headerTitle}
        customHeaderAction={<div></div>}
      />
    )
  }
}

Stepper3 = withStyles(styles.stepper3)(Stepper3)

class Stepper4 extends React.Component {
  render() {
    const { classes, data, headerTitle } = this.props
    var items, type, turn, level, datetime, isOtherAnswers
    items = constants.puzzleTypeItems.filter((item) => item.value === data.type)
    type = items.length > 0 ? (<Word wid={items[0].wid}/>) : ''
    turn = constants.turnType.BLACK
    items = constants.puzzleLevelItems.filter((item) => item.value === data.level)
    level = items.length > 0 ? items[0].label : ''
    datetime = data.checkDateTime ? dateformat(new Date(data.datetime), 'yyyy/m/d HH:MM') : (<Word wid={WID.PUZZLE_REGISTER.STEPPER4.IMMEDIATELY_POST}/>)
    items = constants.puzzleTurnItems.filter((item) => item.value === data.card.puzzleInfo.turn)
    turn = items.length > 0 ? (<Word wid={items[0].wid}/>) : 'error'
    isOtherAnswers = data.isOtherAnswers ? (
      <Word wid={WID.PUZZLE_REGISTER.STEPPER4.OTHER_ANSWERS_YES}/>
    ) : (
      <Word wid={WID.PUZZLE_REGISTER.STEPPER4.OTHER_ANSWERS_NO}/>
    )

    return (
      <Card className={classes.card}>
        <CardHeader
          title={headerTitle}
          className={classes.cardHeader}
        />
        <CardContent>
          <Table className={classes.table}>
            <TableBody>
              <TableRow><TableCell style={{width: '50%'}}><Word wid={WID.PUZZLE_REGISTER.STEPPER1.TITLE_LABEL}/></TableCell><TableCell>{data.title}</TableCell></TableRow>
              <TableRow><TableCell><Word wid={WID.PUZZLE_REGISTER.STEPPER1.PUZZLE_TYPE_LABEL}/></TableCell><TableCell>{type}</TableCell></TableRow>
              <TableRow><TableCell><Word wid={WID.PUZZLE_REGISTER.STEPPER1.TURN_TYPE_LABEL}/></TableCell><TableCell>{turn}</TableCell></TableRow>
              <TableRow><TableCell><Word wid={WID.PUZZLE_REGISTER.STEPPER1.LEVEL_LABEL}/></TableCell><TableCell>{level}</TableCell></TableRow>
              <TableRow><TableCell><Word wid={WID.PUZZLE_REGISTER.STEPPER1.RELEASE_DATE_LABEL}/></TableCell><TableCell>{datetime}</TableCell></TableRow>
              <TableRow><TableCell><Word wid={WID.PUZZLE_REGISTER.STEPPER1.OTHER_ANSWERS_LABEL}/></TableCell><TableCell>{isOtherAnswers}</TableCell></TableRow>
              <TableRow><TableCell><Word wid={WID.PUZZLE_REGISTER.STEPPER1.COMMENT_LABEL}/></TableCell><TableCell>{data.comment}</TableCell></TableRow>
              <TableRow>
                <TableCell><Word wid={WID.PUZZLE_REGISTER.STEPPER1.TAG_LABEL}/></TableCell>
                <TableCell>
                  {data.tags && data.tags.map((tag, index) => 
                    <Chip key={index} label={tag} className={classes.chip}/>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <div className={classes.boardViewBox}>
            <div className={classes.boardAndTitleBox}>
              <Typography><Word wid={WID.PUZZLE_REGISTER.STEPPER4.PUZZLE}/></Typography>
              <div className={classes.renjuBoardBox}>
                <RenjuBoard
                  type='View'
                  moves={data.card.moves.filter((move) => move.number === 0)}
                  isVisibleNumber={true}
                />
              </div>
            </div>
            <div className={classes.boardAndTitleBox}>
              <Typography><Word wid={WID.PUZZLE_REGISTER.STEPPER4.ANSWER}/></Typography>
              <div className={classes.renjuBoardBox}>
                <RenjuBoard
                  type='View'
                  moves={data.card.moves}
                  isVisibleNumber={true}
                />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    )
  }
}

Stepper4 = withStyles(styles.stepper4)(Stepper4)


const steps = [
  { wid: WID.PUZZLE_REGISTER.HORIZONTAL_LINEAR_STEPPER.INFORMATION, node: <Stepper1/> },
  { wid: WID.PUZZLE_REGISTER.HORIZONTAL_LINEAR_STEPPER.PUZZLE,      node: <Stepper2/> },
  { wid: WID.PUZZLE_REGISTER.HORIZONTAL_LINEAR_STEPPER.ANSWER,      node: <Stepper3/> },
]

const PuzzleRegister = (props) => {
  const { classes, theme, user, id, activeStep, completed, title, type, level, datetime, checkDateTime, tag, tags, isOtherAnswers, comment, isFetching, isCompleted, result, ready, bid, card, openConfirmDialog, horizontalLinearStepper, stepperControlButtons, stepper1, confirmDialogProps, windowWidth, handleNextRegistration } = props
  var data, actionGridProps, action

  const [isInitialize, setIsInitialize] = useState(false)
  const [listenerID, setListenerID] = useState()

  const auth0Context = useContext(Auth0Context)

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const dispatch = useDispatch()

  useEffect(() => {
    if (!isInitialize) {
      dispatch({ type: types.puzzleRegister.INIT })
      setIsInitialize(true)
    }
  }, [isInitialize])

  useEffect(() => {
    window.scrollTo(0, 0)
    if (!props.id) {
      return
    }
    if (auth0Context.isAuthenticated) {
      if (auth0Context.user) {
        props.init()
      }
      else {
        props.history.push(makePath('/puzzle', language))
      }
    }
    setListenerID(auth0Context.onAuthStateChanged(changedUser => {
      if (auth0Context.user) {
        props.init()
      }
      else {
        props.history.push(makePath('/puzzle', language))
      }
    }))
    return () => {
      if (listenerID) {
        auth0Context.unregisterAuthStateChanged(listenerID)
      }
    }
  }, [auth0Context.isAuthenticated])

  data = {
    id,
    title,
    type,
    level,
    datetime,
    checkDateTime,
    isOtherAnswers,
    comment,
    tags,
    bid,
    card,
  }
  actionGridProps = windowWidth < theme.breakpoints.values.sm ? { style: { marginTop: theme.spacing.unit * 2 } } : { style: { marginTop: theme.spacing.unit * 1 } }
  action = (
    <StepperControlButtons
      id={id}
      data={data}
      completed={completed}
      activeStep={activeStep}
      isFetching={isFetching}
      stepperControlButtons={stepperControlButtons}
    />
  )

  return (
    <div>
      <TitleGrid titleType='puzzle' menuItems={<PuzzleMenuItems/>}>
        {id && ready === false && (
          <Grid item xs={12} style={{textAlign: 'center'}}>
            <CircularProgress size={40}/>
          </Grid>
        )}
        {(!id || (id && ready === true)) && user && (
          <React.Fragment>
            <Grid item xs={12}>
              {isCompleted === false ? (
                <div className={classes.horizontalLinearStepper}>
                  <HorizontalLinearStepper
                    data={data}
                    activeStep={activeStep}
                    completed={completed}
                    horizontalLinearStepper={horizontalLinearStepper}
                  />
                </div>
              ) : 
              isCompleted === true && result === true ? (
                <div className={classes.resultBox}>
                  <Typography variant='title' align='center' style={{marginBottom: theme.spacing.unit * 2}}>
                    {id ? (
                      <Word wid={WID.PUZZLE_REGISTER.MESSAGE_RESULT_SUCCESSFUL_UPDATE}/>
                    ) : (
                      <Word wid={WID.PUZZLE_REGISTER.MESSAGE_RESULT_SUCCESSFUL_REGISTRATION}/>
                    )}
                  </Typography>
                  <div style={{display: 'flex', justifyContent: 'center'}}>
                    {!id && (
                      <Button
                        component={Link}
                        to={makePath('/puzzle/register', language)}
                        variant="text"
                        color="primary"
                        className={classes.button}
                        onClick={handleNextRegistration}
                      >
                        <Word wid={WID.PUZZLE_REGISTER.NEXT_REGISTRATION_BUTTON}/>
                      </Button>
                    )}
                    <Button
                      component={Link}
                      to={makePath('/puzzle', language)}
                      variant="text"
                      color="primary"
                      className={classes.button}
                    >
                      <Word wid={WID.PUZZLE_REGISTER.GO_TO_PUZZLE_LIST_BUTTON}/>
                    </Button>
                  </div>
                </div>
              ) : 
              isCompleted === true && result === false ? (
                <div className={classes.resultBox}>
                  <Typography variant='title' align='center' style={{marginBottom: theme.spacing.unit * 2}}>
                    {id ? (
                      <Word wid={WID.PUZZLE_REGISTER.MESSAGE_RESULT_FAILED_UPDATE}/>
                    ) : (
                      <Word wid={WID.PUZZLE_REGISTER.MESSAGE_RESULT_FAILED_REGISTRATION}/>
                    )}
                  </Typography>
                  <div style={{display: 'flex', justifyContent: 'center'}}>
                    <Button
                      variant="text"
                      color="primary"
                      onClick={stepperControlButtons.handleBackFirst(data)}
                      className={classes.button}
                    >
                      <Word wid={WID.PUZZLE_REGISTER.STEPPER1.CONTROL_BUTTONS.BACK_BUTTON}/>
                    </Button>
                    <Button
                      component={Link}
                      to={makePath('/puzzle', language)}
                      variant="text"
                      color="primary"
                      className={classes.button}
                    >
                      <Word wid={WID.PUZZLE_REGISTER.GO_TO_PUZZLE_LIST_BUTTON}/>
                    </Button>
                  </div>
                </div>
              ) : <div></div>}
            </Grid>
            <Grid item xs={12}>
              {activeStep === 0 ? (
                <Stepper1
                  {...{ title, type, level, datetime, checkDateTime, isOtherAnswers, tag, tags, comment, stepper1 }}
                  headerTitle={
                    <Typography className={classes.headerTitle} variant='title'>
                      <Word wid={steps[activeStep].wid}/>
                    </Typography>
                  }
                />
              ) :
              activeStep === 1 ? (
                <Stepper2
                  bid={bid}
                  headerTitle={
                    <Typography className={classes.headerTitle} variant='title' style={{paddingTop: theme.spacing.unit}}>
                      <Word wid={steps[activeStep].wid}/>
                    </Typography>
                  }
                />
              ) :
              activeStep === 2 ? (
                <Stepper3
                  bid={bid}
                  headerTitle={
                    <Typography className={classes.headerTitle} variant='title' style={{paddingTop: theme.spacing.unit}}>
                      <Word wid={steps[activeStep].wid}/>
                    </Typography>
                  }
                />
              ) :
              activeStep === 3 && isCompleted === false ? (
                <Stepper4
                  data={data}
                  headerTitle={
                    <Typography className={classes.headerTitle} variant='title'>
                      <Word wid={WID.PUZZLE_REGISTER.HORIZONTAL_LINEAR_STEPPER.INPUTTED_CONTENT}/>
                    </Typography>
                  }
                />
              ) : <div></div>}
            </Grid>
            {isCompleted === false && (
              <Grid item xs={12} {...actionGridProps}>
                {action}
              </Grid>
            )}
          </React.Fragment>
        )}
      </TitleGrid>
      <Dialog open={openConfirmDialog} onClose={confirmDialogProps.handleClose}>
        <DialogTitle>
          <Word wid={WID.PUZZLE_REGISTER.DELETE_ANSWER_CONFIRM_DIALOG.TITLE}/>
        </DialogTitle>
        <DialogContent>
          <Typography>
            <Word wid={WID.PUZZLE_REGISTER.DELETE_ANSWER_CONFIRM_DIALOG.CONTENT}/>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmDialogProps.handleOK(data)} color="primary">
            OK
          </Button>
          <Button onClick={confirmDialogProps.handleClose} color="primary">
            Canncel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default withStyles(styles.puzzleRegister, { withTheme: true })(PuzzleRegister)



// WEBPACK FOOTER //
// ./src/Pages/Puzzle/components/PuzzleRegister.js